import { useSelector } from '@tabeeb/store'
import { useCallback, useRef, useState } from 'react'
import * as usersSelectors from '../../selectors'
import { PluginUser } from '../../types'

const useUserOptions = (user: PluginUser) => {
  const optionsVisibilitySelector = useSelector(usersSelectors.makeGetIsUserOptionsButtonVisible)
  const isVisible = useSelector((state) => optionsVisibilitySelector(state, { user }))

  const deviceOptionsVisibilitySelector = useSelector(usersSelectors.makeGetIsUserDeviceOptionsButtonVisible)
  const isDeviceMenuVisible = useSelector((state) => deviceOptionsVisibilitySelector(state, { user }))

  const healthInfoOptionsVisibilitySelector = useSelector(usersSelectors.makeGetIsHealthInfoOptionsVisible)
  const isHealthInfoOptionsVisible = useSelector((state) => healthInfoOptionsVisibilitySelector(state, { user }))

  const certificatesOptionsVisibilitySelector = useSelector(usersSelectors.makeGetIsCertificatesOptionsVisible)
  const isCertificatesMenuVisible = useSelector((state) => certificatesOptionsVisibilitySelector(state, { user }))

  const isCurrentUserOptionsVisible = isDeviceMenuVisible || isHealthInfoOptionsVisible || isCertificatesMenuVisible

  const buttonRef = useRef<HTMLElement | null>(null)
  const [open, setOpen] = useState(false)

  const onOpen = useCallback(() => {
    setOpen(true)
  }, [])

  const onClose = useCallback(() => {
    setOpen(false)
  }, [])

  return {
    enabled: isVisible || isCurrentUserOptionsVisible,
    isDeviceMenuVisible,
    isHealthInfoOptionsVisible,
    isCertificatesMenuVisible,
    isCurrentUserOptionsVisible,
    isVisible,
    buttonRef,
    open,
    onOpen,
    onClose,
  }
}

export default useUserOptions
